import Skeleton from "@mui/material/Skeleton";

const GeneralSkeleton = ({ variant = "text", sx = {}, ...rest }) => {
  return (
    <Skeleton variant={variant} sx={{ fontSize: "1rem", ...sx }} {...rest} />
  );
};

export default GeneralSkeleton;
